export interface Question {
    _id: string,
    text: string,
    text2: string,
    index?: number,
    language?: string,
    company: string,
    category: string,
    typ: string
    // company: Company,
    // category: Category
}

export function getEmptyQuestion() {
    return {
        text: "neu",
        text2: "",
        index: 0,
        language: "de",
        company: "",
        category: "",
        typ: ""
    }
}
